import styled from 'styled-components'

export const SwitchingConfirmModalContainer = styled.div``

export const TitleWrapper = styled.div`
  width: 100%;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`

export const ButtonsWrapper = styled.div`
  width: 100%;

  margin-top: 30px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`